import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => {
        setSubscribed(false);
      }, 3000);
    }
  };

  return (
    <footer id="contact" className="relative overflow-hidden" style={{ backgroundColor: '#0F232D' }} role="contentinfo">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-12">
        <div className="grid lg:grid-cols-3 gap-12 mb-16">
          {/* Contact */}
          <div>
            <h4 className="text-slate-400 font-inter text-xs uppercase tracking-widest mb-6">CONTACT</h4>
            <div className="space-y-4">
              <a href="tel:+33612345678" className="flex items-center gap-3 text-white hover:text-voyage-gold transition-colors group cursor-pointer">
                <div className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center group-hover:bg-voyage-gold/20 transition-colors">
                  <i className="ri-phone-line text-lg" aria-hidden="true"></i>
                </div>
                <span className="font-inter text-sm">+33 6 12 34 56 78</span>
              </a>
              <a href="mailto:contact@voyageelit.fr" className="flex items-center gap-3 text-white hover:text-voyage-gold transition-colors group cursor-pointer">
                <div className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center group-hover:bg-voyage-gold/20 transition-colors">
                  <i className="ri-mail-line text-lg" aria-hidden="true"></i>
                </div>
                <span className="font-inter text-sm">contact@voyageelit.fr</span>
              </a>
              <a href="https://wa.me/33612345678" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white hover:text-voyage-gold transition-colors group cursor-pointer">
                <div className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center group-hover:bg-voyage-gold/20 transition-colors">
                  <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
                </div>
                <span className="font-inter text-sm">WhatsApp</span>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <nav aria-label="Navigation du pied de page">
            <h4 className="text-slate-400 font-inter text-xs uppercase tracking-widest mb-6">
              NAVIGATION
            </h4>
            <ul className="space-y-2" role="list">
              <li>
                <a href="/" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Accueil</strong> - Transfert privé Genève Lyon
                </a>
              </li>
              <li>
                <a href="/services" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Services</strong> - VTC premium stations de ski
                </a>
              </li>
              <li>
                <a href="/tarifs" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Tarifs</strong> - Prix transfert aéroport
                </a>
              </li>
              <li>
                <a href="/stations" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Stations</strong> - Courchevel Chamonix Val d'Isère
                </a>
              </li>
              <li>
                <a href="/galerie" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Galerie</strong> - Photos véhicules et services
                </a>
              </li>
              <li>
                <a href="/contact" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Contact</strong> - Réservation chauffeur privé
                </a>
              </li>
              <li>
                <a href="/blog" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Blog</strong> - Conseils transfert montagne
                </a>
              </li>
              <li>
                <a href="/reservation" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Réservation</strong> - Réserver en ligne
                </a>
              </li>
              <li>
                <a href="/mon-compte" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Mon compte</strong> - Historique & avis
                </a>
              </li>
              <li>
                <Link to="/legal" className="text-slate-300 hover:text-voyage-gold transition-colors font-inter text-sm cursor-pointer group">
                  <strong className="group-hover:underline">Mentions légales</strong> - CGV & Conformité
                </Link>
              </li>
            </ul>
          </nav>

          {/* Réseaux sociaux */}
          <div>
            <h4 className="text-slate-400 font-inter text-xs uppercase tracking-widest mb-6">SUIVEZ-NOUS</h4>
            <div className="space-y-4">
              <a 
                href="https://www.linkedin.com/in/misakyan-armen-886150241/" 
                className="flex items-center gap-3 text-slate-300 font-inter text-sm hover:text-voyage-gold transition-colors group" 
                rel="nofollow noopener" 
                target="_blank" 
                aria-label="Suivez Voyage Elite sur LinkedIn"
              >
                <i className="ri-linkedin-line text-lg" aria-hidden="true"></i>
                <span className="group-hover:underline">LinkedIn</span>
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61577063254070" 
                className="flex items-center gap-3 text-slate-300 font-inter text-sm hover:text-voyage-gold transition-colors group" 
                rel="nofollow noopener" 
                target="_blank" 
                aria-label="Suivez Voyage Elite sur Facebook"
              >
                <i className="ri-facebook-line text-lg" aria-hidden="true"></i>
                <span className="group-hover:underline">Facebook</span>
              </a>
              <a 
                href="https://share.google/VEalsxTMS1ZZAy3uz" 
                className="flex items-center gap-3 text-slate-300 font-inter text-sm hover:text-voyage-gold transition-colors group" 
                rel="nofollow noopener" 
                target="_blank" 
                aria-label="Trouvez Voyage Elite sur Google My Business"
              >
                <i className="ri-google-line text-lg" aria-hidden="true"></i>
                <span className="group-hover:underline">Google My Business</span>
              </a>
            </div>
          </div>
        </div>

        {/* Grande signature */}
        <div className="relative">
          <div 
            className="font-inter font-extrabold text-center leading-none select-none"
            style={{ 
              fontSize: 'clamp(60px, 10vw, 120px)',
              color: '#E6DCD2',
              letterSpacing: '-0.02em'
            }}
            aria-hidden="true"
          >
            MY DRIVER VTC
          </div>
        </div>

        {/* Copyright et mentions légales */}
        <div className="text-center pt-8 border-t border-white/10 space-y-2">
          <p className="text-white/70 font-inter text-sm">
            © 2017 <strong>My Driver VTC Marseille</strong> • Par Armen Misakyan • Tous droits réservés
          </p>
          <p className="text-white/60 font-inter text-xs">
            1 Rue Marie de Coulange, 13009 Marseille, France • SIREN 828362772 • 
            <Link to="/legal" className="hover:text-voyage-gold transition-colors ml-2 underline">
              Mentions légales et CGV
            </Link>
            <span className="mx-2">•</span>
            <a href="https://readdy.ai/?ref=logo" rel="nofollow noopener" target="_blank" className="hover:text-voyage-gold transition-colors underline">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
